import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const GetProposalGoodsRequestSchema = z
  .object({
    campaignProposalId: z.number(),
    page: z.number().min(1).optional(),
    size: z.number().min(1).max(100).optional(),
  })
  .describe('GetProposalGoodsRequestSchema');

export type GetProposalGoodsRequest = z.infer<typeof GetProposalGoodsRequestSchema>;

const ProposalGoodsItemSchema = z
  .object({
    goodsImageUrl: z.string(),
    linkUrl: z.string(),
    goodsNo: z.number(),
    goodsName: z.string(),
    price: z.number(),
    discountedPrice: z.number(),
  })
  .describe('ProposalGoodsItemSchema');

const GetProposalGoodsResponseDataSchema = z.object({
  list: z.array(ProposalGoodsItemSchema),
});

const GetProposalGoodsResponseSchema = createApiResponseSchema(GetProposalGoodsResponseDataSchema);

export type GetProposalGoodsResponse = z.infer<typeof GetProposalGoodsResponseSchema>;

export const getProposalGoods = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetProposalGoodsRequestSchema),
    async (params: GetProposalGoodsRequest): Promise<GetProposalGoodsResponse> =>
      executeStandardRequest(async () => {
        const { campaignProposalId, ...queryParams } = params;
        const response = await privateHttpClient.get<GetProposalGoodsResponse>(
          urlJoin(campaignsApiPath.getProposalGoods(campaignProposalId)),
          queryParams,
        );
        return response;
      }),
    validateApiResponse(GetProposalGoodsResponseSchema),
  ),
);
